<div class="row row-padding-bottom client-plans">
  <div class="medium-12 column" style="margin-bottom: 10px;">
    <div class="row">
      <div class="medium-3 scenarios">
        <span style="font-size: 20px;font-weight: 500;color: #333333">Strategy List</span>
        <span class="scenario-dropdown" style="display: inline-block;margin-left: 15px;" *ngIf="selectedTableRows.length>0">
          <label>
            <app-tpiq-select-dropdown #strategyActionsDropdown [setData]="actionsData" [includeNone]="false" (onValueSelect)="applyAction($event)"
                                   [setDefaultValue]="" [setSearchKey]="'name'" [setPlaceHolder]="'Actions'" [setValueKey]="'name'" [(ngModel)]="selectedAction"></app-tpiq-select-dropdown>

        </label>
        </span>
      </div>
      <div class="medium-9">
        <!-- Add Strategy button -->
        <div class="float-right pointer" style="color: #1570EF;display: inline-flex;" (click)="addNewStrategy()">
          <i class="material-icons">add</i><span style="position: relative;top: 2px;">Add a strategy</span>
        </div>
        <!-- Open in RAP button - Only show for plans created from 1040 uploads (has documentId) -->
        <div class="float-right icon-gap" *ngIf="clientTaxPlan && clientTaxPlan.id && clientTaxPlan.documentId">
          <span class="text-center badge-tooltip">
            <div class="pointer" style="color: #1570EF;display: inline-flex; align-items: center;" (click)="openPlanInRAPMode()">
              <i class="material-icons" style="font-size: 20px;">launch</i><span style="position: relative;top: 2px;font-weight: 500; margin-left:4px;">Open in RAP</span>
            </div>
            <span class="bottomTooltiptext" style="width:360px; padding: 5px; z-index:9999">
              Re-opens the Read, Analyze, Propose workflow for this client using the data and strategies from the 1040 previously provided. You can edit existing strategy recommendations, adjust client data, then override or create a new plan at the end of the RAP process.
            </span>
          </span>
        </div>
        <div class="float-right icon-gap">
        <span class="text-center badge-tooltip">
        <div *ngIf="!isReorderMode" class="float-right pointer" style="color: #1570EF;display: inline-flex;" (click)="enableReorderMode()">
          <i class="material-icons">
            swap_vert
          </i>
          Set Report Order
        </div>
         <span class="bottomTooltiptext" style="width:160px; padding: 5px; z-index:9999">
          Choose the order in which tax strategies appear on the Return on Investment and Report tabs.
         </span>
        </span>
      </div>
      <div class="float-right icon-gap">
      <button *ngIf="isReorderMode" class="button btn bg-danger d-flex align-items-center gap-1 mb-0" style="height: 32px;" (click)="cancelReorderMode()">
      <i class="material-icons" style="font-size: 18px;">autorenew</i>
      Cancel
    </button>
    </div>
      <div class="float-right icon-gap" *ngIf="isReorderMode">
        <button class="bg-info button mb-0" (click)="applyReorder()" [disabled]="!isOrderChanged">Apply</button>
      </div>
        <div class="float-right icon-gap">
          <input class="pointer" type="checkbox" [(ngModel)]="showActualColumn" (change)="showActualColumnForStrategies()"/> Actual
        </div>
        <ng-template [ngIf]="showActualColumn">
          <div class="float-right icon-gap">
            <input class="pointer" type="checkbox" [(ngModel)]="showDollarChangeColumn" (change)="showDollarChangeColumnForStrategies()"/> $ Change
          </div>
          <div class="float-right icon-gap">
            <input class="pointer" type="checkbox" [(ngModel)]="showPercentageChangeColumn" (change)="showPercentageChangeColumnForStrategies()"/> % Change
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="medium-12 indy-tables badge-tables tp-desc tracker-desc">
    <app-tracker-paginated-table #planStrategiesTable [setObj]="tableData" *ngIf="hasStrategies" (onRowAction)="handleStrategyTableAction($event)" (onSort)="sortByColumn($event)"
                             [emptyText]="'Click + Strategy button at top to start adding strategies'"
                             (onInputSearchSelection)="optionSelected($event)" (onInputBlur)="updateInput($event)"
                             (onRowSelect)="handleSelect($event)" [reorderMode]="isReorderMode" (orderChanged) = "handleOrderChanged($event)"
    ></app-tracker-paginated-table>
  </div>
</div>

<div *ngIf="reveal['goalDateUpdateForPayPerPlan']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['goalDateUpdateForPayPerPlan']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 55%;" [ngClass]="{'tpiq-reveal': reveal['goalDateUpdateForPayPerPlan']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Task Goal Date</span>
      <span class="float-right pointer" (click)="hideReveal('goalDateUpdateForPayPerPlan')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <div>Please purchase this plan to produce the ROI, Presentation, Report, Timeline, and Tasks.</div>
          <div style="font-size: 14px;margin-top: 5px;">For more information <a style="text-decoration: underline;" href="https://www.taxplaniq.com/pay-per-plan" target="_blank">click here</a>.</div>
        </div>
      </div>
      <div class="row-padding-reveal text-right">
        <button class="button small" (click)="confirm()">Pay</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['strategyNotes']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['strategyNotes']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 85%;" [ngClass]="{'tpiq-reveal': reveal['strategyNotes']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">{{currentNotesStrategy.strategyName}}</span>
      <span class="float-right pointer" (click)="hideReveal('strategyNotes')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <div class="row">
        <div class="medium-12 columns">
          <label>
            Notes for implementing {{currentNotesStrategy.strategyName}} (internal note):
            <textarea placeholder="Write your notes here." [(ngModel)]="currentNotesStrategy.notes" style="height: 100px; resize: none;"></textarea>
          </label>
        </div>
      </div>
      
      <!-- Why this applies -->
      <div class="row">
        <div class="medium-12 columns">
          <label>
            Why this applies to you (shown in report) :
            <textarea 
              placeholder="Why this applies to you"
              [(ngModel)]="currentNotesStrategy.reportCustomText"
              style="height: 100px; resize: none;">
            </textarea>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns">
          <button class="button small float-right" (click)="updateNotesForStrategy()" [disabled]="freezPlan || userReadOnly">Update</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['addStrategy']">
  <div class="reveal-overlay" (click)="minimizeReveal('addStrategy')" [ngClass]="{'tpiq-reveal': reveal['addStrategy']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['addStrategy']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">{{editMode? 'Update': 'Add New'}} Strategy</span>
      <span class="float-right pointer" (click)="hideReveal('addStrategy')">X</span>
      <span class="float-right">
        <i class="material-icons" style="font-size: 1.7em;margin-right: 6px" (click)="minimizeReveal('addStrategy')">keyboard_arrow_down</i>
      </span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body new-input-fields">
      <div class="row" style="height: 80vh;overflow-y: scroll;">
        <div class="medium-6 columns">
          <label>
            Payor: <span style="color: #F06459">*</span>
            <app-tpiq-select-dropdown [setData]="clientsList" [includeNone]="false" (onValueSelect)="setClient($event)"
                                   [setDefaultValue]="newStrategy.clientId" [setSearchKey]="'name'" [setPlaceHolder]="'Pick Payor'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Tax Strategies: <span style="color: #F06459">*</span>
            <app-tpiq-select-dropdown [setData]="filteredStrategies" [includeNone]="false" (onValueSelect)="setStrategy($event)"
                                   [setDefaultValue]="newStrategy.strategyId" [setSearchKey]="'name'" [setPlaceHolder]="'Pick Strategy'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns mt-3">
          <label>
            <span>Create Task Date</span>
            <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline"></i><span class="pe-2">:</span>
              <span class="bottomTooltiptext" style="width: 250px;">
                A task will be created for the strategy once you fill in the task date field here.
              </span>
            </span>
            <input class="float-left input-field" type="text" tpiq-custom-datepicker [attr.format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="newStrategy.goalDate"
                   placeholder="Create Task Date" (valueChanged)="updateGoalDate($event, newStrategy)"/>
          </label>
        </div>
        <div class="medium-6 columns mt-3">
          <label>Recurring
            <div>
              <input type="checkbox" [(ngModel)]="newStrategy.recurring" [checked]="newStrategy.recurring" />
            </div>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Start Year: <span style="color: #F06459">*</span>
            <app-tpiq-input-search [setData]="years" [setColName]="''" [setPlaceHolder]="'Start Year'" [setMasterRow]="''" [setSearchKey]="'name'" [setValueKey]="'id'"
                                [setDefaultValue]="newStrategy.sinceYear" (onValueSelect)="selectYear($event, 'sinceYear')"
                                (onCharacterTyped)="selectYear($event, 'sinceYear')"></app-tpiq-input-search>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            End Year:
            <app-tpiq-input-search [setData]="years" [setColName]="''" [setPlaceHolder]="'End Year'" [setMasterRow]="''" [setSearchKey]="'name'" [setValueKey]="'id'"
                                [setDefaultValue]="newStrategy.toYear" (onValueSelect)="selectYear($event, 'toYear')"
                                (onCharacterTyped)="selectYear($event, 'toYear')"></app-tpiq-input-search>
          </label>
        </div>
        <div class="medium-6 columns mt-3">
          <label>
            Est. Plan Amount:
            <input class="float-left input-field" placeholder="Est. Plan Amount" type="text" [(ngModel)]="newStrategy.amount" (blur)="calculateResultAmount(newStrategy, true)"
                   model-numeral [locale]="'USD'" [format]="'$0,0'" [readonly]="newStrategy.isInvestmentEnabled && isInvestmentFeature"/>
          </label>
        </div>
        <!-- Investment Field-->
        <div class="medium-6 columns mt-3" *ngIf="newStrategy.isInvestmentEnabled && isInvestmentFeature">
          <label>
            Strategy Investment Amount:
        
            <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline"></i>
              <span class="pe-2">: </span>
              <span class="bottomTooltiptext" style="width: 220px;">
                The investment value is calculated by applying the defined strategy formula to the invested amount
              </span>
            </span>
            <input class="float-left input-field" placeholder="Investment Value" type="text"
              [(ngModel)]="newStrategy.investedAmount" (ngModelChange)="calculateInvestmentAmount(newStrategy)" model-numeral
              [locale]="'USD'" [format]="'$0,0'" />
          </label>
        </div>
        <div class="medium-6 columns mt-3">
          <label>
            Actual Amount:
            <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline"></i>
              <span class="pe-2">: </span>
              <span class="bottomTooltiptext" style="width: 340px;">
                Do NOT use this field until you've implemented the plan and finalized the exact deduction, credit, etc that you produced for the client. Fill in that final number once available, to show a comparable of Planned Versus Actual ROI on the reports.
              </span>
            </span>
            <input class="float-left input-field" placeholder="Actual Amount" type="text" [(ngModel)]="newStrategy.actualAmount" (blur)="calculateResultAmount(newStrategy, true)"
                   model-numeral [locale]="'USD'" [format]="'$0,0'" [disabled]="!editMode"/>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Federal Associated Rate: <span style="color: #F06459">*</span>
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="allAssociatedData[newStrategy.strategyId] || associatedWith" (onValueSelect)="setAssociatedWith($event, 'federal')"
                                   [setDefaultValue]="defaultStrategyId" [setSearchKey]="'name'" [setPlaceHolder]="'Pick Fed Rate'" [setValueKey]="'id'">
            </app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            State Associated Rate:
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="allStateAssociatedData" (onValueSelect)="setAssociatedWith($event, 'state')"
                                   [setDefaultValue]="defaultStateAssociatedId" [setSearchKey]="'name'" [setPlaceHolder]="'Pick State Rate'" [setValueKey]="'id'">
            </app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns mt-3 mb-3" *ngIf="newStrategy.roiAmount">
          <span>Fed Tax Saved</span>
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline"></i><span class="pe-2">: </span>
            <span class="bottomTooltiptext" style="width: 180px;">
               {{ newStrategy.actualAmount === 0 || !newStrategy.actualAmount ? 'Plan Amount times Federal Associated Rate' : 'Actual Amount times Federal Associated Rate' }}
            </span>
          </span>
          <span class="text-right total-color">{{newStrategy.roiAmount | formatAmount:'$0,0'}}</span>
        </div>
        <div class="medium-6 columns mt-3 mb-3" *ngIf="newStrategy.stateRoiAmount">
          <span>State Tax Saved</span>
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline"></i><span class="pe-2">: </span>
            <span class="bottomTooltiptext" style="width: 180px;">
               {{ newStrategy.actualAmount === 0 || !newStrategy.actualAmount ? 'Plan Amount times Federal Associated Rate' : 'Actual Amount times Federal Associated Rate' }}
            </span>
          </span>
          <span class="text-right total-color">{{newStrategy.stateRoiAmount | formatAmount:'$0,0'}}</span>
        </div>
        <div class="medium-12 columns" style="margin-bottom: 15px;">
          <span class="pointer add-text" (click)="toggleAddCustomRate(!showAddCustomRateInPopup)">
            <span style="position: relative;bottom: 3px;">
              <i class="icon float-left add-icon ion-ios-plus-outline" *ngIf="!showAddCustomRateInPopup"></i>
              <i class="icon float-left add-icon ion-ios-minus-outline" *ngIf="showAddCustomRateInPopup"></i>
            </span>
            Custom Rate
          </span>
        </div>
        <div class="medium-12 columns" *ngIf="showAddCustomRateInPopup" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding: 15px;margin-bottom: 15px;">
          <div class="row">
            <div class="small-5 columns">
              <input type="text" [(ngModel)]="newCustomRate.name" placeholder="Name"/>
            </div>
            <div class="small-3 columns">
              <input type="text" [(ngModel)]="newCustomRate.rate" placeholder="24"/>
            </div>
            <div class="medium-2">
              <span style="position: relative;top: 5px;">(OR)</span>
              <span class="badge-tooltip">
                  <span style="position: relative;top: 5px;padding-left: 10px;">
                    <i class="icon ion-ios-calculator-outline" style="font-size: 24px" (click)="openFormulaCalculator(newCustomRate)"></i>
                    <span class='bottomTooltiptext tpActionTooltip' style="font-size: 14px !important;width: 150px !important;">Build your formula</span>
                  </span>
                </span>
            </div>
            <div class="small-2 columns">
              <button class="pointer" style="padding: 7px 15px;background: #FFFFFF;margin-top: 5px;border: 1px solid #1570EF;border-radius: 6px;color: #0B58CB;" (click)="appendNewCustomRate()">Add</button>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns">
          <button class="small button float-right" style="margin-bottom: 0 !important;" (click)="saveNewStrategy()">{{editMode? 'Update': 'Save'}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row min-wall-add-task minimized-add-strategy" *ngIf="isMinimized">
  <div class="small-6 medium-8 columns min-title">{{editMode ? 'Update Strategy!' : 'Add Strategy!'}}</div>
  <div class="small-6 medium-4 columns" style="text-align: right">
    <span><i class="material-icons min-task" (click)="addNewStrategy()">keyboard_arrow_up</i></span>
    <span><i class="material-icons min-close" (click)="hideReveal('addStrategy', true)">clear</i></span>
  </div>
</div>

<div *ngIf="reveal['fromulaCalculator']">
  <app-formula-builder (buildAssociatedObject)="buildAssociatedObject()" (onHideReveal)="hideReveal('fromulaCalculator')"
                       (onProgpageCustomRate)="propageCustomRateChange($event)" (onUpdateTaxRatesInFormula)="updateTaxRatesInFormula()"
                       (refreshTableData)="refreshTableData()" (triggerCloseAddCustomRateInStrategyPage)="triggerCloseAddCustomRateInStrategyPage($event)"
                       (triggerCloseEditCustomRate)="triggerCloseEditCustomRate($event)"
                       (triggerRecalcAndUpdatePlan)="triggerRecalcAndUpdatePlan($event)"
                       [actionType]="'create'"
                       [addingCustomRatesArray]="tempCustomTaxRates"
                       [allAssociatedData]="allAssociatedData"
                       [associatedWith]="associatedWith"
                       [clientTaxPlan]="clientTaxPlan"
                       [customRate]="tempCustomRateObject"
                       [fixedRatesArray]="fixedRatesArray"
                       [indexOfTempCustomObj]="indexOfTempCustomRateObject"
                       [isCustomRateEdit]="isCustomRateEdit"></app-formula-builder>
</div>

<div *ngIf="reveal['copyStrategiesToOtherPlan']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['copyStrategiesToOtherPlan']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 40%;" [ngClass]="{'tpiq-reveal': reveal['copyStrategiesToOtherPlan']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Copy Strategies to Other Plan</span>
      <span class="float-right pointer" (click)="hideReveal('copyStrategiesToOtherPlan')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body new-input-fields" style="padding: 15px;">
      <div class="row" style="padding-bottom: 15px;">
        <div class="medium-10 columns">
          <label>
            Client:
            <app-tpiq-select-dropdown [setData]="listOfAllClients" [includeNone]="false" (onValueSelect)="onClientSelect($event)"
                                   [setDefaultValue]="selectedClientId" [setSearchKey]="'name'" [setPlaceHolder]="'Select a client'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-10 columns text-right">
          <a (click)="openCreatePopup('Client')"><u style="font-size: 12px;padding-right: 20px;">Create a new Client</u></a>
        </div>
      </div>
      <div class="row"  *ngIf="selectedClient" style="padding-bottom: 15px;">
        <div class="medium-10 columns">
          <label>
            Plan:
            <app-tpiq-select-dropdown [setData]="clientPlans" [includeNone]="false" (onValueSelect)="onClientPlanSelect($event)"
                                   [setDefaultValue]="selectedPlanId" [setSearchKey]="'name'" [setPlaceHolder]="'Select a plan'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-10 columns text-right">
          <a (click)="openCreatePopup('Plan')"><u style="font-size: 12px;padding-right: 20px;">Create a new Plan</u></a>
        </div>
      </div>
      <div class="row mt-3">
        <div class="medium-12 columns">
          <button class="button small float-right" [ngStyle]="{'background': (selectedClient && selectedPlan) ? '#1570EF':'#98A2B3'}" (click)="copyStrategiesToOther()">Copy</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['createTemplate']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['createTemplate']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 70%;" [ngClass]="{'tpiq-reveal': reveal['createTemplate']}">
    <div class="body" style="padding: 15px;height: 90vh;">
      <app-create-or-update-template [editMode]="false" (onCancelCreateOrUpdateOfTemplate)="hideReveal('createTemplate')"
                                   [isFromPlan]="true" [selectedStrategiesFromPlan]="selectedStrategiesForTemplate"
                                   (onCreationOrUpdateOfTemplate)="hideReveal('createTemplate')"></app-create-or-update-template>
    </div>
  </div>
</div>

<div *ngIf="reveal['addOrEditClient']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['addOrEditClient']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['addOrEditClient']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Create a New Client</span>
      <span class="float-right pointer" (click)="hideReveal('addOrEditClient')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <app-create-or-update-client [editMode]="false" (onCancelCreateOrUpdateOfClient)="hideReveal('addOrEditClient')"
                                 (onCreationOrUpdateOfClient)="refreshListOfClients($event)"></app-create-or-update-client>
    </div>
  </div>
</div>

<div *ngIf="reveal['addPlan']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['addPlan']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['addPlan']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Create a New Tax Plan</span>
      <span class="float-right pointer" (click)="hideReveal('addPlan')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <app-create-plan [client]="selectedClient" (onCancelCreatePlan)="hideReveal('addPlan')"
                        (onCreationOfPlan)="refreshListOfPlans($event)"></app-create-plan>
    </div>
  </div>
</div>

<div *ngIf="reveal['viewStrategyInfo']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['viewStrategyInfo']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 80%;" [ngClass]="{'tpiq-reveal': reveal['viewStrategyInfo']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Strategy Info</span>
      <span class="float-right pointer" (click)="hideReveal('viewStrategyInfo')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <app-view-tax-strategy [strategyId]="selectedStrategyIdForView" [viewOnly]="true"></app-view-tax-strategy>
    </div>
  </div>
</div>

<div class="task-date-modal" *ngIf="hasGoalDate">
  <div class="modal_header" role="dialog" aria-modal="true">
    <header class="d-flex justify-content-between gap-2 align-items-start">
      <h3>
        Date required for task
      </h3>

      <div class="text-dark">
        <span class="pointer" (click)="closeGoalDateModal()">X</span>
      </div>
    </header>

    <div class="mb-4">
      <p>
        Date is required for the task. Do you want to provide a date to keep the task,
        or delete the task instead?
      </p>

      <label for="taskDate">
        Enter new due date:
      </label>

      <input id="taskDate" type="date" [(ngModel)]="modalSelectedDate" />

    </div>

    <footer class="d-flex justify-content-end gap-3 align-items-center">
      <button (click)="onKeepAndUpdate()" [disabled]="!modalSelectedDate" class="button_primary">
        Update
      </button>

      <button class="button_delete" (click)="onDeleteTask()">
        Delete
      </button>

    </footer>
  </div>
</div>
